"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UserManager_1 = require("../../util/UserManager");
exports.default = UserManager_1.OidcReducer;
//# sourceMappingURL=reducers.js.map